<template>
  <div class="w-full rounded-lg bg-brand-3 p-4 lg:mt-4">
    <div v-if="!reserved && qty">
      <div class="flex items-center between">
        <div class="flex items-center gap-2">
          <span class="h-4 w-4 rounded-full bg-green-30" />
          <p class="body-1 fw-bold">
            {{ $t.reservationAvailable }}
          </p>
        </div>
        <base-button class="overline-1 underlined o:capitalize" @click="emit('reserve')">
          {{ $t.reserve }}
        </base-button>
      </div>
      <p class="mt-1 flex items-center gap-2 caption-1 c-grey-40">
        <span>{{ defaultStore.name }}</span>
        <base-button class="underlined" @click="emit('change-store')">
          {{ $t.changeStore.title }}
        </base-button>
      </p>
      <span v-if="qty && qty < 10" class="caption-1 c-red-30">
        {{ replaceAll($t.qtyLimitLow, { limit: qty }) }}
      </span>
    </div>
    <base-button
      v-else
      :disabled="reserved"
      :loading
      @click="emit('click')"
    >
      <p class="fw-bold">
        {{ buttonCta.title }}
      </p>
      <p v-html="buttonCta.subtitle" class="caption-1 c-grey-40" />
      <p v-if="!variantId" class="caption-1 c-grey-40">
        {{ $t.completeSelection }}
      </p>
    </base-button>
  </div>
</template>

<script lang="ts" setup>
import type { Emits, Props } from '#commerce/components/product/cta/ReserveInStore.vue'
import type { LocatorSearchItem } from '#types/brandify'

const { reserved, variantId } = defineProps<Props>()

const emit = defineEmits<Emits>()

const { products } = useApi()
const { $t } = useNuxtApp()
const defaultStore = useLocalStorage('defaultStore', {} as LocatorSearchItem)

const qty = ref(0)
const loading = ref(false)

const buttonCta = computed(() => reserved
  ? { title: $t.reservedItem, subtitle: $t.checkEmailForDetails }
  : { title: $t.checkAvailabilityInStore, subtitle: $t.useZipOrCurrentLocation }
)

watchEffect(async () => {
  qty.value = 0
  const storeId = defaultStore.value?.storeid
  if (reserved || !variantId || !storeId) return

  loading.value = true
  try {
    const { storeInventory } = await products.$getStoreInventory(variantId, [{ storeId }])
    qty.value = storeInventory?.find((inv) => inv.storeId === storeId)?.quantity ?? 0
  }
  catch (err) {
    log.error(`[ReserveInStore] Failed to get store inventory: ${err}`)
    qty.value = 0
  }
  finally {
    loading.value = false
  }
})
</script>
